import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    card: 'space-y-2',
    description: 'line-clamp-2 text-xs <lg:hidden',
    image: 'mb-4',
    title: 'line-clamp-2 text-sm fw-bold',
  }
} satisfies VfConfig['articleCard']
